import cssVars from "css-vars-ponyfill";

export default cssVars({
  variables: {
    "--bg-opacity": "1",
    "--text-opacity": "1",
    "--border-opacity": "1",
  },
});
